import React from 'react';
import styled from 'styled-components';

import LoginForm from './loginForm';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const LoginPage = () => (
  <Container>
    <LoginForm />
  </Container>
);

export default LoginPage;
